<template>
  <v-row v-if="isMovil">
    <v-row class="py-12 mx-0 primary" align="center" justify="center">
      <v-col cols="12" sm="12" md="6" lg="5">
        <v-card light elevation="8" class="rounded-lg" data-aos="fade-right">
          <v-card-title>
            <h3 class="primary--text">
              Recibe más información: <br />
              <small
                >¡Nosotros nos pondremos <br />
                en contacto contigo!
              </small>
            </h3>
          </v-card-title>
          <v-card-text class="d-flex justify-center align-center flex-column">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  name="nombre"
                  label="Nombre*"
                  outlined
                  color="primary darken-3"
                  hide-details
                  v-model="name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  name="apellidos"
                  label="Apellidos*"
                  outlined
                  color="primary darken-3"
                  hide-details
                  v-model="lastname"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  name="correo"
                  label="Correo electrónico*"
                  outlined
                  color="primary darken-3"
                  hide-details
                  v-model="email"
                  required
                  class="input"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  name="movil"
                  label="Teléfono*"
                  outlined
                  color="primary darken-3"
                  hide-details
                  v-model="phone"
                  v-mask="'##########'"
                  required
                  class="input"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-select
                :items="offer"
                item-text="text"
                item-disabled="isDisabled"
                text="isDisabled"
                name="cp22"
                label="Oferta de interés*"
                hide-details
                class="input"
                outlined
                v-model="carrer"
                return-object
                ></v-select>
              </v-col>
              <v-col md="12">
                <v-select
                  class="input"
                  :items="states_2"
                  label="Estado*"
                  name="idestado"
                  v-model="state"
                  outlined
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      readonly
                      v-on="on"
                      label="Fecha de nacimiento*"
                      v-model="computedDateFormatted"
                      hint="DD/MM/YYYY"
                      placeholder="DD/MM/YYYY"
                      outlined
                      name="cp9"
                      type="text"
                      id="birthday"
                      @click="datePicker = true"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    locale="es"
                    v-model="birthday"
                    @input="menu1 = false"
                    ref="picker"
                    :max="new Date().toISOString().substr(0, 10)"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" class="d-flex flex-column justify-end align-end">
                <vue-recaptcha
                  @expired="successRecaptcha = false"
                  @verify="reCAPTCHAcallback()"
                  sitekey="6LeWh6oaAAAAAK4-nrEuFXkV1g_9Pf8btl5XAWeB"
                  :loadRecaptchaScript="true"
                ></vue-recaptcha>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-btn 
                  color="primary"
                  @click="sendInscription"
                  large
                  block
                  rounded
                  class="button-vizcaya white--text"
                  :disabled="loading || !successRecaptcha"
                  > 
                  Inscribirse
                </v-btn>
              </v-col>
              <v-col cols="12">
                <router-link to="/informes">
                  <v-btn
                    :loading="loading"
                    color="white"
                    large
                    block
                    rounded
                    class="button-vizcaya primary--text"
                    @click="sendForm"
                    :disabled="loading || !successRecaptcha"
                  >
                    Informes
                  </v-btn>
                </router-link>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-snackbar v-model="snackbar" :color="color" :timeout="3500" top>
          {{ msg }}
          <v-btn color="white" text @click="snackbar = false"> Cerrar </v-btn>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-row>
  <v-flex v-else style="width: 41vw">
    <v-card
      elevation="8"
      light
      class="rounded-lg mx-6"
      data-aos="fade-right"
      style=""
    >
      <v-card-title>
        <h3 class="primary--text">
          Recibe más información: <br />
          <small>¡Nosotros nos pondremos en contacto contigo!</small>
        </h3>
      </v-card-title>
      <v-card-text class="d-flex justify-center align-center flex-column">
        <v-row>
          <v-col cols="6">
            <v-text-field
              name="nombre"
              label="Nombre*"
              outlined
              color="primary darken-3"
              hide-details
              v-model="name"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              name="apellidos"
              label="Apellidos*"
              outlined
              color="primary darken-3"
              hide-details
              v-model="lastname"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              name="correo"
              label="Correo electrónico*"
              outlined
              color="primary darken-3"
              hide-details
              v-model="email"
              required
              class="input"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              name="movil"
              label="Teléfono*"
              outlined
              color="primary darken-3"
              hide-details
              v-model="phone"
              v-mask="'##########'"
              required
              class="input"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-select
              :items="offer"
              item-text="text"
              item-disabled="isDisabled"
              text="isDisabled"
              name="cp22"
              label="Oferta de interés*"
              hide-details
              class="input"
              outlined
              v-model="carrer"
              return-object
            ></v-select>
          </v-col>
          <v-col md="6">
            <v-select
              class="input"
              :items="states_2"
              label="Estado*"
              name="idestado"
              v-model="state"
              outlined
            ></v-select>
          </v-col>
          <v-col cols="12">
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  readonly
                  v-on="on"
                  label="Fecha de nacimiento*"
                  v-model="computedDateFormatted"
                  hint="DD/MM/YYYY"
                  placeholder="DD/MM/YYYY"
                  name="cp9"
                  outlined
                  type="text"
                  id="birthday"
                  @click="datePicker = true"
                ></v-text-field>
              </template>
              <v-date-picker
                locale="es"
                v-model="birthday"
                @input="menu1 = false"
                ref="picker"
                :max="new Date().toISOString().substr(0, 10)"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" class="d-flex flex-column justify-end align-end">
            <vue-recaptcha
              @expired="successRecaptcha = false"
              @verify="reCAPTCHAcallback()"
              sitekey="6LeWh6oaAAAAAK4-nrEuFXkV1g_9Pf8btl5XAWeB"
              :loadRecaptchaScript="true"
            ></vue-recaptcha>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-btn
              :loading="loading"
              color="white"
              large
              block
              class="button-vizcaya primary--text rounded-lg"
              @click="sendForm"
              :disabled="loading || !successRecaptcha"
            >
              Informes
            </v-btn>
          </v-col>
          <v-col cols="12" md="6">
            <v-btn 
              color="primary"
              large
              block
              @click="sendInscription"
              class="button-vizcaya white--text rounded-lg"
              :disabled="loading || !successRecaptcha"
            >
              Inscribirse
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-snackbar v-model="snackbar" :color="color" :timeout="3500" top>
      {{ msg }}
      <v-btn color="white" text @click="snackbar = false"> Cerrar </v-btn>
    </v-snackbar>
    <v-dialog
      v-model="dialogConfirm"
      persistent
      max-width="450"
    >
      <v-card class="ma-0" style="overflow: hidden !important;">
        <v-card-title class="text-center">
          <v-row>
            <v-col cols="12" class="text-center mb-2">
              <v-icon size="84" color="success"> mdi-check-circle-outline </v-icon>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-title class="text-center" style="font-weight: bold; word-break: break-word;">
            <v-row class="mx-0">
                <v-col cols="12" class="text-center">
                    Su correo fue enviado con exito
                </v-col>
            </v-row>
        </v-card-title>
        <v-card-text class="text-center" style="font-size: 18px; word-break: break-word;">
            <span>Recibimos correctamente su información, pronto nuestro equipo se contactara con usted.</span>
        </v-card-text>
        <v-card-actions class="mb-3">
          <v-row class="mx-0">
            <v-col class="text-center" cols="12">
                <v-btn
                    class="rounded-lg"
                    large
                    depressed
                    block
                    color="primary white--text"
                    @click="dialogConfirm = false"
                >
                    ACEPTAR
                </v-btn>
            </v-col>
          </v-row>
        </v-card-actions> 
      </v-card>
    </v-dialog>
  </v-flex>
</template>
<style scoped>
.text-wrap {
  word-break: break-word;
}
.input {
  height: 46px;
}
</style>

<script>
import axios from "axios";
import { mask } from "vue-the-mask";
import moment from "moment";

export default {
  name: "Contacto",
  props: ["isMovil"],
  directives: {
    mask,
  },
  data: () => ({
    dialogConfirm: false,
    menu1: false,
    states_2: [
      { key: "AGS",   text: "Aguascalientes" },
      { key: "BC",    text: "Baja California" },
      { key: "BCS",   text: "Baja California Sur" },
      { key: "CHIH",  text: "Chihuahua" },
      { key: "CHIS",  text: "Chiapas" },
      { key: "CAMP",  text: "Campeche" },
      { key: "DF",    text: "Ciudad De Mexico" },
      { key: "COAH",  text: "Coahuila" },
      { key: "COL",   text: "Colima" },
      { key: "DGO",   text: "Durango" },
      { key: "GRO",   text: "Guerrero" },
      { key: "GTO",   text: "Guanajuato" },
      { key: "HGO",   text: "Hidalgo" },
      { key: "JAL",   text: "Jalisco" },
      { key: "MICH",  text: "Michoacan" },
      { key: "MEX",   text: "México" },
      { key: "MOR",   text: "Morelos" },
      { key: "NAY",   text: "Nayarit" },
      { key: "NL",    text: "Nuevo Leon" },
      { key: "OAX",   text: "Oaxaca" },
      { key: "PUE",   text: "Puebla" },
      { key: "QROO",  text: "Quintana Roo" },
      { key: "QRO",   text: "Queretaro" },
      { key: "SIN",   text: "Sinaloa" },
      { key: "SNL",   text: "San Luis Potosi" },
      { key: "SON",   text: "Sonora" },
      { key: "TAB",   text: "Tabasco" },
      { key: "TLAX",  text: "Tlaxcala" },
      { key: "TAMS",  text: "Tamaulipas" },
      { key: "VER",   text: "Veracruz" },
      { key: "YUC",   text: "Yucatan" },
      { key: "ZAC",   text: "Zacatecas" },
    ],
    offer: [
      { key: "4EBD213C-B93E-48D1-988C-D54F959BC211", name: "Administracion" , text: "Lic. Admin. de empresas"},
      { key: "27676024-2122-40C5-A836-D4009309D0AF", name: "Educacion" , text: "Lic. Ciencias de la educación" },
      { key: "52CE8D18-E9B9-4310-BC5D-8BB4872AFE4A", name: "Contaduria" , text: "Lic. Contaduría" },
      { key: "C07B1B9D-CF73-42D7-BF6E-98CD28705008", name: "Comercio" , text: "Lic. Comercio internacional" },
      { key: "C17F5334-F0F1-4693-93F6-1E116074E812", name: "Derecho" , text: "Lic. Derecho" },
      { key: "0C49D431-DD46-4401-87AF-A85C9311547C", name: "Criminología y criminalística", text: "Lic. Criminología y Criminalística"},
    ],
    inscriptionOptions: [],
    campusSelected: "",
    windowHeight: 0,
    scrollY: 0,
    name: null,
    lastname: null,
    email: null,
    phone: null,
    state: null,
    carrer: null,
    birthday: null,
    date: null,
    menu: false,
    snackbar: false,
    msg: "",
    color: "",
    loading: false,
    citites: [],
    successRecaptcha: false,
    information: {
      name_first: "",
      last_name: "",
      phone: "",
      email: "",
      campus: "",
      carrer: "",
      birthday: "",
      state: "",
    },
  }),
  methods: {
    validateEmail(email) {
      let re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    validatePhone(number) {
      let phone =
        /^[0-9]{10}$/;
      return phone.test(number);
    },
    validateDateIns() {
      let today = new Date();
      let currentYear = parseInt(today.getFullYear());
      let date = this.information.birthday.split("/");
      let yy = parseInt(date[0]);
      if (currentYear - yy > 18) {
        return true;
      }
      return false;
    },
    onScroll(e) {
      var inscriptionsWindow = document.getElementById("main");
      this.windowHeight = inscriptionsWindow.scrollHeight;
      this.scrollY = window.scrollY;
    },
    reCAPTCHAcallback() {
      this.successRecaptcha = true;
    },
    makeReference() {
      var nombre = this.name.replace(" ", "-");
      let state = this.state.substring(0, 3).toLowerCase();
      this.reference = nombre.toLowerCase() + state + this.carrer.name.toLowerCase();
      this.$store.dispatch("setReference", this.reference);
      this.$store.dispatch("setEmail", this.email);
      this.$store.dispatch("setName", this.name);
    },
    sendMailIns() {
      fbq("track", "AddPaymentInfo");
      let self = this;
      axios
        .post("https://www.admin-uva.tidingo.com/api/create-inscription", {
          name: this.name,
          lastname: this.lastname,
          email: this.email,
          phone: this.phone,
          state: this.state,
          carrer: this.carrer.name,
          birthday: this.birthday,
        })
        .then(function (response) {})
        .catch(function (error) {});
    },
    sendInscription() {
      if (
        this.name != null &&
        this.lastname != null &&
        this.email != null &&
        this.phone != null &&
        this.state != null &&
        this.birthday != null &&
        this.carrer != null
      ) {
        this.information.name_first = this.name;
        this.information.last_name = this.lastname;
        this.information.phone = this.phone;
        this.information.email = this.email;
        this.information.carrer = this.carrer.name;
        this.information.birthday = this.birthday;
        this.information.state = this.state;

        if (!this.validateEmail(this.email)) {
          this.msg = "Favor de ingresar un email válido";
          this.color = "warning";
          this.snackbar = true;
          return;
        }
        if (!this.validatePhone(this.phone)) {
          this.msg = "Favor de ingresar un teléfono válido";
          this.color = "warning";
          this.snackbar = true;
          return;
        }
        if (!this.validateDateIns(this.birthday)) {
          this.msg = "Debes tener más de 18 años";
          this.color = "warning";
          this.snackbar = true;
          return;
        }
        this.loading = true;
        this.makeReference();
        if (
          this.information.carrer == "Personal" ||
          this.information.carrer == "Logistica" ||
          this.information.carrer == "Capital"
        ) {
          this.$router.push("/inscripcion_diplomado");
        } else {
          this.$router.push("/inscripcion");
        }
        this.sendMailIns();
      } else {
        this.loading = false;
        this.msg = "Complete todos los datos";
        this.color = "warning";
        this.snackbar = true;
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    sendForm(){
      if (!this.validatePhone(this.phone)) {
        this.msg = "Favor de ingresar un teléfono válido";
        this.color = "warning";
        this.snackbar = true;
        return;
      }
      this.loading = true;
      let now = moment();
      if (
        this.name != null &&
        this.lastname != null &&
        this.email != null &&
        this.phone != null &&
        this.state != null &&
        this.birthday != null &&
        this.carrer != null
      ) {
        axios
          .post("https://api.salesup.com/integraciones/P25AP8F26CCA2-9D28-4158-8ECA-4C8D39E614CB", {
            nombre: this.name,
            apellidos: this.lastname,
            correo: this.email,
            movil: this.phone,
            cp22: this.carrer.key,
            idestado: this.state,
            cp9: this.computedDateFormatted,
            // ----- AD'S
            url: "https://uvaenlinea.uva.edu.mx",
            referrer: "https://www.google.com/",
            browser: "Chrome 105",
            esMovil: this.isMovil,
            gclid: "",
            fbclid: "",
            utm_source: "https://uvaenlinea.uva.edu.mx",
            utm_medium: "Organico",
            utm_campaign: "",
            utm_term: "",
            utm_date: now.toISOString(),
            utm_content: ""
        }).then(response => {
          if(response.data[0].msg == "Ok"){
            this.loading = false;
            this.dialogConfirm = true;
            this.name = '';
            this.lastname = '';
            this.email = '';
            this.phone = '';
            this.carrer = '';
            this.state  = '';
            this.birthday = '';
          }else{
            this.loading = false;
          }
        }).catch(error =>{
          this.loading = false;
        })
      } else {
        this.loading = false;
        this.msg = "Complete todos los datos";
        this.color = "warning";
        this.snackbar = true;
      }
    }
  },
  watch: {
    menu1(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  mounted() {},
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.birthday);
    },
  },
  created() {
    window.addEventListener("scroll", this.onScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
  },
};
</script>
